import { Box, Typography } from "@mui/material";
import { BackArrowIcon } from "src/assets/icons/back-arrow-icon";
import { useIsMobileView } from "../../hooks/use-is-mobile-view";
import { CustomButton } from "../custom-button/custom-button";
import { NavTabs } from "../nav-tabs/nav-tabs";
import { MenuItem } from "../sidebar/sidebar";
import { Search } from "../table/search/search";
import { classes } from "./toolbar.styles";

type ToolbarProps = {
  label: string;
  count?: number;
  countLabel?: string;
  icon?: React.ReactElement;
  showNav?: boolean;
  actionLabel: string;
  isLoading?: boolean;
  showBackButton?: boolean;
  actionClick?: () => void;
  backClick?: () => void;
  onSearch?: (search: string) => void;
};

const tabs: MenuItem[] = [
  {
    label: "Users list",
    link: "/admin-portal/users",
  },
  {
    label: "Active TAGS",
    link: "/admin-portal/active-tags",
  },
];

export const Toolbar: React.FC<ToolbarProps> = ({
  label,
  count,
  countLabel,
  showNav = true,
  isLoading = false,
  showBackButton = false,
  icon,
  actionLabel,
  actionClick,
  backClick,
  onSearch,
}) => {
  const isMobile = useIsMobileView();

  return (
    <Box sx={classes.toolbar}>
      <Box>
        <Box
          sx={{
            ...classes.actions,
            flexDirection: { xs: "column-reverse", sm: "row" },
            marginBottom: ({ spacing }) => ({
              xs: spacing(1),
            }),
          }}
        >
          <Box sx={classes.actions}>
            <Typography sx={classes.label} variant="h3">
              {label}
            </Typography>

            {actionLabel && (
              <CustomButton
                id="action-button"
                buttonType="primary"
                onClick={actionClick}
                isLoading={isLoading}
              >
                {actionLabel}
              </CustomButton>
            )}
          </Box>

          {!isLoading && showBackButton && (
            <Box sx={classes.backButton} onClick={backClick}>
              <BackArrowIcon />
              <Typography color="primary">Go back</Typography>
            </Box>
          )}
        </Box>

        {Number.isInteger(count) && (
          <Box sx={classes.counterWrapper}>
            <Box sx={classes.counter}>
              {icon}
              {count} {countLabel}
            </Box>
            {onSearch && isMobile && (
              <Search onSearch={onSearch} size="small" />
            )}
          </Box>
        )}
      </Box>

      {showNav && !isMobile && (
        <Box
          sx={{
            display: "flex",
            gap: "32px",
          }}
        >
          <NavTabs tabs={tabs} />
          {onSearch && <Search onSearch={onSearch} />}
        </Box>
      )}
    </Box>
  );
};
